import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AiInferenceStreamTextSearchVariables = Types.Exact<{
  input: Types.AIInferenceStreamTextSearchInput;
}>;

export type AiInferenceStreamTextSearch = {
  aiInferenceStreamTextSearch: Pick<Types.AIInferenceStreamTextSearchResultList, 'totalCount'> & {
    edges: Array<{
      node: Pick<
        Types.AIInferenceStreamTextSearchResult,
        | 'streamId'
        | 'title'
        | 'private'
        | 'createdAt'
        | 'userPrompt'
        | 'alias'
        | 'aliasType'
        | 'conversationId'
        | 'isConversation'
      > & {
        snippetWithHighlights: Pick<Types.SnippetWithHighlights, 'text'> & {
          highlights?: Types.Maybe<
            Array<Pick<Types.SnippetHighlight, 'beginOffset' | 'endOffset'>>
          >;
        };
        createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
      };
    }>;
    pageInfo: Pick<
      Types.CursorBasedPaginationPageInfo,
      'hasNextPage' | 'hasPreviousPage' | 'endCursor' | 'startCursor'
    >;
  };
};

export const AiInferenceStreamTextSearchDocument = gql`
  query AiInferenceStreamTextSearch($input: AIInferenceStreamTextSearchInput!) {
    aiInferenceStreamTextSearch(input: $input) {
      edges {
        node {
          snippetWithHighlights {
            text
            highlights {
              beginOffset
              endOffset
            }
          }
          streamId
          title
          private
          createdAt
          createdBy {
            ...ActorTeaser
          }
          userPrompt
          alias
          aliasType
          conversationId
          isConversation
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
      totalCount
    }
  }
  ${ActorTeaser}
`;

/**
 * __useAiInferenceStreamTextSearch__
 *
 * To run a query within a React component, call `useAiInferenceStreamTextSearch` and pass it any options that fit your needs.
 * When your component renders, `useAiInferenceStreamTextSearch` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAiInferenceStreamTextSearch({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAiInferenceStreamTextSearch(
  baseOptions: Apollo.QueryHookOptions<
    AiInferenceStreamTextSearch,
    AiInferenceStreamTextSearchVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AiInferenceStreamTextSearch, AiInferenceStreamTextSearchVariables>(
    AiInferenceStreamTextSearchDocument,
    options,
  );
}
export function useAiInferenceStreamTextSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AiInferenceStreamTextSearch,
    AiInferenceStreamTextSearchVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AiInferenceStreamTextSearch, AiInferenceStreamTextSearchVariables>(
    AiInferenceStreamTextSearchDocument,
    options,
  );
}
export function useAiInferenceStreamTextSearchSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AiInferenceStreamTextSearch,
    AiInferenceStreamTextSearchVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<AiInferenceStreamTextSearch, AiInferenceStreamTextSearchVariables>(
    AiInferenceStreamTextSearchDocument,
    options,
  );
}
export type AiInferenceStreamTextSearchHookResult = ReturnType<
  typeof useAiInferenceStreamTextSearch
>;
export type AiInferenceStreamTextSearchLazyQueryHookResult = ReturnType<
  typeof useAiInferenceStreamTextSearchLazyQuery
>;
export type AiInferenceStreamTextSearchSuspenseQueryHookResult = ReturnType<
  typeof useAiInferenceStreamTextSearchSuspenseQuery
>;
export type AiInferenceStreamTextSearchQueryResult = Apollo.QueryResult<
  AiInferenceStreamTextSearch,
  AiInferenceStreamTextSearchVariables
>;
export function mockAiInferenceStreamTextSearch({
  data,
  variables,
  errors,
}: {
  data: AiInferenceStreamTextSearch;
  variables?: AiInferenceStreamTextSearchVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: AiInferenceStreamTextSearchDocument, variables },
    result: { data, errors },
  };
}
